<template>

    <base-filter :label="label">
        <div class="px-3 py-2 bg-light" v-if="options.length > 5">
            <input type="search" v-model.trim="searchQuery" class="form-control" :placeholder="__('Suche...')">
        </div>
        <div class="p-3 filter__box-scroll">
            <div class="form-check" v-for="option in filteredOptions">
                <label class="form-check-label">
                    <input class="form-check-input" 
                           type="checkbox" 
                           :value="option.id" 
                           v-model="checkedItems"
                           @change="handleInput" />
                    {{ option.label }}
                </label>
            </div>
        </div>
    </base-filter>

</template>

<script>
    import BaseFilter from '@/shared/Filters/BaseFilter';

    export default {
        props: {
            id: {
                type: String,
                default() {
                    return `filter-${this._uid}`
                },
            },
            label: String,
            options: Array,
            value: Array,
        },
        components: {
            BaseFilter,
        },
        data() {
            return {
                searchQuery: '',
                checkedItems: this.value,
            }
        },
        watch: {
            value() {
                this.checkedItems = this.value;
            },
        },
        computed: {
            // @todo Put checked first
            filteredOptions() {
                var searchQuery = this.searchQuery.toLowerCase();
                var filteredOptions = this.options;
                if (searchQuery) {
                    filteredOptions = this.options.filter((option) => {
                        return option.label.toLowerCase().indexOf(searchQuery) > -1 || option.label.replace(/[^a-z0-9]/ig, '').trim().replace(/\s+/g, '-').toLowerCase().indexOf(searchQuery) > -1;
                    });
                }

                return filteredOptions;
            }
        },
        methods: {
            handleInput(e) {
                this.$emit('input', this.checkedItems);
            }
        }
    }
</script>
